// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-62fe346e] {\n  width: 100%;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  font-size: 13px;\n  z-index: 2;\n  color: #333333;\n}\n.footer a[data-v-62fe346e] {\n  color: #666666;\n  text-decoration: none;\n  margin-right: 20px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
